<template>
  <div>
    <v-card>
      <v-toolbar
        dark
        color="secondary"
      >
        <v-toolbar-side-icon><v-icon>mdi-cellphone-arrow-down</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>{{$tc('app.update', 2)}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div
          v-if="$vuetify.breakpoint.smAndDown"
          slot="extension"
          class="white--text w-100"
        >
          <v-text-field
            type="text"
            v-model="filterText"
            @keyup.enter="doFilter"
            :placeholder="$t('library.filterPlaceholder')"
            single-line
            hide-details
          ></v-text-field>
        </div>
        <v-text-field
          v-if="$vuetify.breakpoint.mdAndUp"
          type="text"
          v-model="filterText"
          @keyup.enter="doFilter"
          :placeholder="$t('library.filterPlaceholder')"
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          @click.prevent="doFilter"
          icon
        >
          <v-icon>search</v-icon>
        </v-btn>

        <v-btn
          @click.prevent="resetFilter"
          icon
        >
          <v-icon>restore</v-icon>
        </v-btn>
        <transition
          enter-active-class="animated bounceIn"
          leave-active-class="animated bounceOut"
        >
          <v-btn
            v-if="selectedRows !== undefined && selectedRows.length !== 0"
            @click.prevent="massDeleteModalVisible = true"
            icon
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </transition>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          v-show="loading"
          slot="progress"
          color="accent"
          indeterminate
        ></v-progress-linear>

        <vuetable
          ref="vuetable"
          data-path="data"
          pagination-path="meta"
          track-by="id"
          :api-url="`${this.apiUrl}api/updates`"
          :http-fetch="httpFetch"
          :fields="fields"
          :css="css.table"
          :sort-order="sortOrder"
          :multi-sort="true"
          :append-params="moreParams"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loading="onLoading"
          @vuetable:loaded="onLoaded"
        >

          <div
            slot="actions-slot"
            slot-scope="props"
          >
            <v-btn
              @click.native="showDeleteUpdateDialog(props.rowData)"
              flat
              icon
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </div>
        </vuetable>
      </v-card-text>
      <v-card-actions>
        <vuetable-pagination ref="pagination"
          :css="css.pagination"
          @vuetable-pagination:change-page="onChangePage"
        ></vuetable-pagination>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="deleteModalVisible"
      max-width="500px"
    >
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline">{{ $tc("library.deleteUpdate", 1) }}</h3>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="deleteModalVisible = false"
            flat
          >{{ $t("general.close") }}</v-btn>
          <v-btn
            @click.prevent="deleteUpdate()"
            color="accent"
          >{{ $t("general.delete") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import VueTableMixin from '@/components/generic/VueTableMixin';
import VueTableMaterialDesignCheckbox from '@/components/generic/VueTableMaterialDesignCheckbox.vue';
import 'animate.css/animate.css';

export default {
  mixins: [
    VueTableMixin,
  ],
  data() {
    return {
      fields: [
        {
          name: VueTableMaterialDesignCheckbox,
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'id',
          title: 'ID',
          sortField: 'id',
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'name',
          title: this.$i18n.t('general.name'),
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'size',
          title: this.$i18n.t('general.size'),
          sortField: 'size',
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'actions-slot',
          title: this.$i18n.tc('general.action', 2),
          titleClass: 'text-xs-center',
          dataClass: 'text-xs-center',
        },
      ],
      css: {
        table: {
          tableClass: 'v-table v-datatable',
          ascendingIcon: 'mdi mdi-sort-ascending',
          descendingIcon: 'mdi mdi-sort-descending',
        },
      },
      sortOrder: [
        { field: 'id', sortField: 'id', direction: 'asc' },
      ],
      deleteModalVisible: false,
      massDeleteModalVisible: false,
    };
  },
  created() {
    this.$events.off('refresh-update-table');

    this.$events.$on('refresh-update-table', () => {
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    });
  },
  methods: {
    showDeleteUpdateDialog(update) {
      this.currentUpdate = update;
      this.deleteModalVisible = true;
    },
    deleteUpdate() {
      this.deleteModalVisible = false;
      this.deleteItem('update', this.currentUpdate.id);
    },
    massDeleteUpdate() {
      this.massDeleteModalVisible = false;
      this.massDeleteItems('update', {
        data: {
          ids: this.$refs.vuetable.selectedTo,
        },
      });
    },
  },
};
</script>

<style scoped>

</style>
